export class ExamCall {
    Id: number;
    Description: string;
    Type: string;
    SchoolYearId: number;
    Month: number;
    CallNumber: number | null;

    constructor() {
        this.Id = 0;
        this.Description = '';
        this.Type = '';
        this.SchoolYearId = 0;
        this.Month = 0;
        this.CallNumber = null;
    }
}



// WEBPACK FOOTER //
// ./src/app/main/models/exam-calls/exam-call.ts